export default __webpack_public_path__ + "static/media/sj-2-rMIN.5e98b7df.avif";